import type { RoundName } from "../../domain/round/types";

const API_BASE = String(import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/$/, "");

export type GeneratorGroupOverride = {
  group: number;
  tv: boolean;
  requiredScorers: number;
  coverageScorers: number;
  teePin: boolean;
};

export type GeneratorDraft = {
  tournamentId: string;
  roundName: RoundName;
  overrides: GeneratorGroupOverride[];
  updatedAt?: string;
  updatedBy?: string;
};

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    ...init,
    headers: {
      Accept: "application/json",
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = body && typeof body === "object" && "detail" in body ? String((body as { detail?: unknown }).detail || "") : "";
    throw new Error(detail || `HTTP ${response.status}`);
  }
  return body as T;
}

export function loadGeneratorDraft(tournamentId: string, round: RoundName) {
  return request<GeneratorDraft>(`/tournaments/${encodeURIComponent(tournamentId)}/generator/draft/${round}`);
}

export function saveGeneratorDraft(tournamentId: string, round: RoundName, overrides: GeneratorGroupOverride[]) {
  return request<GeneratorDraft>(`/tournaments/${encodeURIComponent(tournamentId)}/generator/draft/${round}`, {
    method: "PUT",
    body: JSON.stringify({ overrides }),
  });
}
